import React, { useEffect } from "react";
import { OpusCard } from "../../components/opuses";

const OpusList = (props) => {
  const opuses = props.opuses;
  console.log(opuses);

  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  return (
    <section>
      <div className="mypage-container">
        <div className="center center-box">
          <div>
            {opuses.length > 0 &&
              opuses.map((opus) => (
                <OpusCard
                  key={opus.id}
                  id={opus.id}
                  images={opus.images}
                  price={opus.price}
                  name={opus.name}
                  description={opus.description}
                  size={opus.size}
                />
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OpusList;
